export const UserInfoSkeleton = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3">
      <div className="size-40 animate-pulse rounded-full bg-gray-200" />
      <div className="h-12 w-3/4 animate-pulse rounded-lg bg-gray-200" />
      <div className="flex w-3/4 flex-row items-center justify-center gap-3">
        <div className="h-10 w-1/3 animate-pulse rounded-lg bg-gray-200" />
        <div className="h-10 w-1/3 animate-pulse rounded-lg bg-gray-200" />
        <div className="h-10 w-1/3 animate-pulse rounded-lg bg-gray-200" />
      </div>
      <div className="h-40 w-full animate-pulse rounded-lg bg-gray-200" />
    </div>
  );
};
